import { createFileRoute } from "@tanstack/react-router";
import { MembersPage } from "../../../components/settings/members-page";

export const Route = createFileRoute("/_authenticated/_workspace/settings/members")({
  component: MembersPage,
});
